/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Val_MeditationInputs */

const en_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meditation`)
};

const es_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meditación`)
};

const fr_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Méditation`)
};

const de_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meditation`)
};

const ja_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`瞑想`)
};

const zh_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`冥想`)
};

const ar_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`تأمل`)
};

const id_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meditasi`)
};

const it_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meditazione`)
};

const ru_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Медитация`)
};

const pt_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meditação`)
};

const ko_val_meditation = /** @type {(inputs: Val_MeditationInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`명상`)
};

/**
* | output |
* | --- |
* | "Meditation" |
*
* @param {Val_MeditationInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const val_meditation = /** @type {((inputs?: Val_MeditationInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Val_MeditationInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_val_meditation(inputs)
	if (locale === "es") return es_val_meditation(inputs)
	if (locale === "fr") return fr_val_meditation(inputs)
	if (locale === "de") return de_val_meditation(inputs)
	if (locale === "ja") return ja_val_meditation(inputs)
	if (locale === "zh") return zh_val_meditation(inputs)
	if (locale === "ar") return ar_val_meditation(inputs)
	if (locale === "id") return id_val_meditation(inputs)
	if (locale === "it") return it_val_meditation(inputs)
	if (locale === "ru") return ru_val_meditation(inputs)
	if (locale === "pt") return pt_val_meditation(inputs)
	return ko_val_meditation(inputs)
});